export enum TradeOfferListTabsEnum {
  DRAFT = 'draft',
  OPEN = 'open',
  ACCEPTED = 'accepted',
  DECLINED = 'declined',
  DELETED = 'deleted',
  TEMPLATE = 'template',
  ALL = 'all',
}
